const stock = () => {

    function stockController() {
        var totalWidth = 0;
        var widthLimit = $('.StockMenu').innerWidth() - 104;
        $('.StockMenu-hamberger').css('display', 'none');
        //menu reset 
        menuReset();
        if ($(window).innerWidth() >= 1200) {
            $('.StockMenu > ul > li').each(function () {

                var itemWidth = $(this).outerWidth() + 22;
                totalWidth += itemWidth;
                if (totalWidth > widthLimit) {
                    $('.MenuMore > ul').append($(this));
                }
                $(this).css('visibility', 'visible');
            })
            if (totalWidth > widthLimit) {
                $('.StockMenu-hamberger').css('display', 'flex');
            }
        }
    }

    $('.StockMenu-hamberger').click(function () {
        $('.MenuMore').toggle();
        $(this).toggleClass('open');
        event.stopPropagation();
    })

    $(document).click(function () {
        if ($('.StockMenu-hamberger').hasClass('open')) {
            $('.MenuMore').css('display', 'none');
            $('.StockMenu-hamberger').removeClass('open');
        }
    })

    $(document).ready(function () {
        ($('.StockDescription--mobile') as any).owlCarousel({
            rtl: true,
            dots: false,
            nav: true,
            responsive: {
                0: {
                    items: 1
                },
                769: {
                    items: 2
                }
            }
        });
    })

    $(document).ready(stockController);
    window.addEventListener("resize", stockController);
    window.addEventListener("orientationChange", stockController);
};

function menuReset() {
    $('.MenuMore > ul > li').each(function () {
        $('.StockMenu > ul').append($(this));
    })
}


export {
    stock
};
